import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Users, UserPlus } from 'lucide-react';

interface AutoPopulateModalProps {
  isOpen: boolean;
  onClose: () => void;
  onAutoPopulateAll: () => void;
  onAutoPopulateUnassigned: () => void;
}

export default function AutoPopulateModal({
  isOpen,
  onClose,
  onAutoPopulateAll,
  onAutoPopulateUnassigned,
}: AutoPopulateModalProps) {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Auto Populate Guests</DialogTitle>
          <DialogDescription>
            Automatically seat guests on this floor plan, keeping relationship groups together. Guests
            already seated on another floor plan are left where they are.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4 py-4">
          <div className="space-y-2">
            <p className="text-sm text-muted-foreground">
              Choose how to auto-populate guests:
            </p>
            
            <div className="space-y-3">
              <Button
                variant="default"
                className="w-full justify-start"
                onClick={() => {
                  onAutoPopulateAll();
                  onClose();
                }}
              >
                <Users className="mr-2 h-4 w-4" />
                <div className="flex flex-col items-start">
                  <span className="font-semibold">Reassign All Guests</span>
                  <span className="text-xs text-muted-foreground font-normal">
                    Clear this plan's seats and reseat everyone not on another plan
                  </span>
                </div>
              </Button>

              <Button
                variant="outline"
                className="w-full justify-start"
                onClick={() => {
                  onAutoPopulateUnassigned();
                  onClose();
                }}
              >
                <UserPlus className="mr-2 h-4 w-4" />
                <div className="flex flex-col items-start">
                  <span className="font-semibold">Assign Unassigned Only</span>
                  <span className="text-xs text-muted-foreground font-normal">
                    Only seat guests who have no seat on any plan
                  </span>
                </div>
              </Button>
            </div>
          </div>

          <div className="flex justify-end gap-2 pt-4">
            <Button variant="outline" onClick={onClose}>
              Cancel
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}

